import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n-lite';
import { connect } from 'react-redux';

class SadMonster extends React.Component {
  static propTypes = {
    emptyImg: PropTypes.any,
    msgKey: PropTypes.any
  };

  render() {
    const { emptyImg, msgKey } = this.props;

    let emptyImgUrl = emptyImg ? <img src={emptyImg} alt="presentation" /> : '';

    return (
      <div className="sad-monster-container">
        <div>
          {emptyImgUrl}
          <div className="text" style={{ fontStyle: 'italic' }}>
            {I18n.t(msgKey)}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    emptyImg: state.theme.images.placeholders.empty
  };
}

export default connect(mapStateToProps)(SadMonster);
